import { useState } from 'react';
import { Link } from 'react-router-dom';

import useStateHandler from '@/hooks/useStateHandler';
import AuthService from '@/services/auth.service';
import MandatoryPopupResultsService from '@/services/mandatoryPopupResults.service';
import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import TextInput from '@/shared-components/inputs/components/new/TextInput';
import PublicFormInput from '@/shared-components/inputs/components/PublicFormInput';

import AuthSuccessText from '../../components/AuthSuccessText';

import './styles/AuthArtistCreateAccount.css';

export default function AuthArtistCreateAccount({ oobCode }) {
  const { stateHandler, state } = useStateHandler();
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  async function signUpArtist(e) {
    e.preventDefault();
    setLoading(true); 
    setError(null); 

    if(!termsAccepted) {
      setError({ element: "user_terms", error_code: "TERMS_NOT_ACCEPTED" });
      setLoading(false);
      return;
    }
        
    if(password !== confirmPassword) {
      setError({ element: "user_confirm_password", error_code: "PASSWORD_MISMATCH" });
      setLoading(false);
      return;
    }

    const { response, data } = await AuthService.registerArtist(oobCode, confirmPassword, state.invite);
  
    if(response.ok) {
      try {
        await AuthService.initUserSession(stateHandler, setLoading, data);
        MandatoryPopupResultsService.createMandatoryPopupResult(
          { result: "signup_success" },
          { useStoredContext: true, clearStoredContext: true }
        ).catch((error) => {
          console.error('Failed to persist mandatory popup artist signup success', error);
        });
      } catch (error) {
        console.error('Failed to initialize user session', error);
        alert('We could not complete your sign in. Please try again.');
        setLoading(false);
        return;
      }
    } else if(response.status === 400 || response.status === 409) {
      setLoading(false);
      setError({ element: response.status === 409 ? "user_confirm_password" : data.error_data.element, error_code: data.error_type });
    } else {
      alert("This link has already been used or it has expired.");
      setLoading(false);
    }
    
  }

  return (
    <>
      <AuthSuccessText>Congratulations! Your Artist Profile has been verified.</AuthSuccessText>

      <form onSubmit={signUpArtist} className="auth-artist-create-account__form">
        <TextInput 
          type="password"
          error={error}
          label="Password"
          placeholder='Password'
          value={password} element="user_confirm_password" margin 
          onChange={(e) => setPassword(e.target.value)}
        />

        <TextInput 
          type="password"
          error={error}
          label="Confirm password"
          placeholder='Confirm password'
          value={confirmPassword} element="user_password" margin 
          onChange={(e) => setConfirmPassword(e.target.value)} 
        />

        <PublicFormInput error={error} element="user_terms" type="checkbox" value={termsAccepted} onChange={value => setTermsAccepted(value)} className="auth-artist-create-account_terms">
                    I accept <span className="auth-artist-create-account__terms" ><Link to="/terms" target='_blank' >terms and conditions</Link></span>.
        </PublicFormInput>
                            
        <ContinueButton loading={loading} className="auth-artist-create-account__submit-button" turnOff={!termsAccepted || !password || !confirmPassword}> 
                    Continue 
        </ContinueButton>
      </form>
    </>
  );
}
